import { DNode } from '@dojo/framework/core/interfaces';
import { theme } from '@dojo/framework/core/mixins/Themed';
import { v } from '@dojo/framework/core/vdom';
import { Keys } from '@holmescorp/common';
import { I18nThemed } from '@holmescorp/interfaces/mixins';
import { keymap, pathmap } from '@holmescorp/lcc-state';
import { TopicAttrs, TopicDetails } from '@holmescorp/lcc-state/interfaces';

import css from '../css/topicset.m.css';
import { TopicProperties } from '../interfaces';

export interface TopicSetProperties extends TopicProperties {
	topichead: TopicDetails;
	as_toc?: boolean;
}

@theme(css)
export class TopicSet extends I18nThemed<TopicSetProperties> {
	protected toc_click(): void {
		const {
			topic: { attributes = {} as TopicAttrs }
		} = this.properties;
		const { key } = attributes;
		console.log('toc action for', key);
	}

	protected head_click(): void {
		const {
			topic: { attributes = {} as TopicAttrs }
		} = this.properties;
		const { key } = attributes;
		const { path } = keymap.get(key)!;
		const { view } = pathmap.get(path)!;
		view();
	}

	protected render(): DNode {
		const {
			topic: { attributes = {} as TopicAttrs },
			as_toc = false
		} = this.properties;
		const { title, key } = attributes;

		return v(
			'div',
			{
				key,
				tabIndex: 0,
				classes: [this.theme(css.root)],
				onclick: (event) => {
					event && event.stopImmediatePropagation();
					as_toc ? this.toc_click() : this.head_click();
				},
				onkeydown: (event: KeyboardEvent) => {
					const { as_toc } = this.properties;

					switch (event.key) {
						case Keys.Enter:
						case Keys.Space:
						case Keys.Spacebar:
							event.preventDefault();
							as_toc ? this.toc_click() : this.head_click();
							break;
					}
				}
			},
			[v('div', { classes: [this.theme(css.title)] }, [title])]
		);
	}
}
